import React from "react";
import { Switch } from "react-router-dom";
import RouteLoader from "services/route-loader";

const Routes = () => (
  <Switch>
    <RouteLoader exact path="/" loader={() => import("modules/home")} />
    <RouteLoader
      exact
      path="/authenticate"
      loader={() => import("modules/authenticate")}
    />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js